import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../shell/Logo';
import { cn } from '../../utils/cn';

const PRODUCT_LINKS = [
  { id: 'how', label: "So funktioniert's" },
  { id: 'pricing', label: 'Preise' },
  { id: 'faq', label: 'FAQ' },
];

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  const reduceMotion = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
}

export interface SiteFooterProps {
  /** Extra classes on the root `<footer>`, e.g. bottom padding to reserve space for
   * LandingPage's mobile sticky CTA so it never covers this footer's content (M8). */
  className?: string;
}

/** The landing page's only footer (the shared `Footer` is hidden on `/`, see Task 4). */
export const SiteFooter: React.FC<SiteFooterProps> = ({ className }) => (
  <footer id="site-footer" className={cn('border-t border-line bg-page', className)}>
    <div className="mx-auto w-full max-w-wide px-4 py-12 md:px-6">
      <div className="grid gap-8 md:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-3 max-w-xs text-sm text-muted">
            Automatische Benachrichtigungen für neue Wohnungsangebote in ganz Deutschland.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-ink">Produkt</h3>
          <ul className="mt-3 flex flex-col gap-2 text-sm text-muted">
            {PRODUCT_LINKS.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    scrollToId(link.id);
                  }}
                  className="hover:text-ink hover:underline"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-ink">Rechtliches</h3>
          <ul className="mt-3 flex flex-col gap-2 text-sm text-muted">
            <li>
              <Link to="/impressum" className="hover:text-ink hover:underline">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="hover:text-ink hover:underline">
                Datenschutz
              </Link>
            </li>
            <li>
              <Link to="/agb" className="hover:text-ink hover:underline">
                AGB
              </Link>
            </li>
            <li>
              <Link to="/widerruf" className="hover:text-ink hover:underline">
                Widerrufsbelehrung
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-ink">Kontakt</h3>
          <ul className="mt-3 flex flex-col gap-2 text-sm text-muted">
            <li>
              <a href="mailto:support@schneller-wohnen.net" className="hover:text-ink hover:underline">
                support@schneller-wohnen.net
              </a>
            </li>
            <li>
              <a href="https://t.me/your_support" className="hover:text-ink hover:underline">
                Telegram Support
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p className="mt-10 text-xs text-muted">&copy; 2026 Schneller Wohnen. Alle Rechte vorbehalten.</p>
    </div>
  </footer>
);

export default SiteFooter;
